import { Text, Paper, Container, Loader, Stack } from "@mantine/core";
import { loginWithToken } from "./authApi";
import { useEffect, useRef } from "react";
import { notifications } from "@mantine/notifications";
import { useStore } from "../store";

export default function LoginLinkHandler({ params }) {
  const initialized = useRef(false);
  const userLoggedIn = useStore((state) => state.userLoggedIn);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loginWithToken(params.token)
        .then((data) => {
          console.log("loginWithToken returned", data);
          userLoggedIn(data);
          notifications.show({ title: "Logged in", color: "green" });
          // userLoggedIn honors MCP OAuth returnUrl; otherwise it navigates home.
        })
        .catch((err) => {
          notifications.show({
            title: "Error",
            message: err.message,
            color: "red",
          });
        });
    }
  }, [params.token]);

  return (
    <Container size="sm" mt="xl">
      <Paper radius="md" p="xl" withBorder>
        <Stack gap="sm" align="center">
          <Loader size="xl" />
          <Text>Logging you in...</Text>
        </Stack>
      </Paper>
    </Container>
  );
}
